const P: Record<string, string> = {
  home: "M3 11l9-8 9 8M5 10v10h14V10",
  clock: "M12 7v5l3 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0",
  field: "M4 20l4-12 4 7 3-4 5 9z",
  briefcase: "M3 8h18v11H3zM8 8V5h8v3M3 13h18",
  learn: "M4 5h6a3 3 0 0 1 3 3v12a2 2 0 0 0-2-2H4zM20 5h-6a3 3 0 0 0-3 3v12a2 2 0 0 1 2-2h7z",
  people: "M2.5 20a6.5 6.5 0 0 1 13 0M9 11.5A3.5 3.5 0 1 0 9 4.5a3.5 3.5 0 0 0 0 7zM15 20h6.5a5 5 0 0 0-5-5M17 11.5a2.5 2.5 0 1 0 0-5",
  inbox: "M4 4h16v12H4zM4 16l4-4h8l4 4M4 16v4h16v-4",
  more: "M5 12h.01M12 12h.01M19 12h.01",
  gear: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.01a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.01a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z",
  funnel: "M3 5h18l-7 8v5l-4 2v-7z",
  chart: "M4 20V10M10 20V4M16 20v-8M20 20H2",
  truck: "M1 6h13v10H1zM14 9h4l3 3v4h-7zM6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  ruler: "M3 17l14-14 4 4L7 21zM8 12l2 2M11 9l2 2M14 6l2 2",
  star: "M12 3l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.8 6.2 20.9l1.1-6.5L2.6 9.8l6.5-.9z",
  mail: "M3 5h18v14H3zM3 6l9 7 9-7",
  calendarDay: "M4 5h16v15H4zM4 9h16M8 3v4M16 3v4M12 13h.01",
  driveTri: "M8 3h8l5 9-4 7H7l-4-7zM8 3l4 9M16 3l-9 16",
  qb: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zM9 9v6a2.5 2.5 0 0 0 0-5h-1M15 15V9a2.5 2.5 0 0 1 0 5h1",
  asana: "M12 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6.5 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17.5 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  signout: "M9 21H4V3h5M15 16l5-4-5-4M20 12H9",
  open: "M14 4h6v6M20 4L10 14M18 13v7H4V6h7",
  check: "M20 6L9 17l-5-5",
  bell: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10 21h4",
  globe: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3 12h18M12 3c2.5 2.6 4 5.7 4 9s-1.5 6.4-4 9c-2.5-2.6-4-5.7-4-9s1.5-6.4 4-9z",
};
export function Icon({ name, size = 18 }: { name: string; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      {(P[name] ?? P.more)!.split("M").filter(Boolean).map((d, i) => <path key={i} d={"M" + d} />)}
    </svg>
  );
}
